module.exports = __webpack_public_path__ + "img/IAOTP.79cfeb01.jpg";